import { useEffect, useRef } from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  BannerBox,
  BannerGridWrapper,
  BannerHeader,
  BannerSection,
  TitleWrapper,
  CertificationImageRow,
} from "@components/layout/home_m_banner/HomeMBanner.styles";
import { useRouter } from "next/router";
import { useBannerStore } from "@store/useBannerStore";

SwiperCore.use([Navigation, Autoplay, Pagination]);

const HomeMobileBanner = () => {
  const router = useRouter();
  const {
    bannerList,
    mobileBtm,

    mainBtmFirstRowLeft,
    mainBtmFirstRowCenter,
    mainBtmFirstRowRight,
    mainBtmSecondRowLeft,
    mainBtmSecondRowCenter,
    mainBtmSecondRowRight,
    mainBtmThirdRowLeft,
    mainBtmThirdRowCenter,
    mainBtmThirdRowRight,
    mainBtmWideSmall,
  } = useBannerStore((s) => s);

  const mobileSwiperRef = useRef();

  useEffect(() => {
    if (
      bannerList &&
      mobileBtm?.length > 1 &&
      mobileSwiperRef.current?.autoplay
    ) {
      mobileSwiperRef.current.autoplay.start();
      mobileSwiperRef.current.autoplay.run();
      mobileSwiperRef.current.update();
    }
  }, [bannerList, mobileBtm]);

  const banners = [
    {
      title: "인증받은 상품",
      subTitle: "골라보기",
      data: [
        ...(mainBtmFirstRowLeft || []),
        ...(mainBtmFirstRowCenter || []),
        ...(mainBtmFirstRowRight || []),
      ],
    },
    {
      title: "스페셜 서비스",
      subTitle: "살펴보기",
      data: [
        ...(mainBtmSecondRowLeft || []),
        ...(mainBtmSecondRowCenter || []),
        ...(mainBtmSecondRowRight || []),
      ],
    },
    {
      data: [
        ...(mainBtmThirdRowLeft || []),
        ...(mainBtmThirdRowCenter || []),
        ...(mainBtmThirdRowRight || []),
      ],
    },
  ];

  const getMobileBanners = (row) => {
    const allBanners = [];
    if (row === "second") {
      if (mainBtmSecondRowLeft?.length)
        allBanners.push(...mainBtmSecondRowLeft);
      if (mainBtmSecondRowCenter?.length)
        allBanners.push(...mainBtmSecondRowCenter);
      if (mainBtmSecondRowRight?.length)
        allBanners.push(...mainBtmSecondRowRight);
      if (mainBtmThirdRowLeft?.length) allBanners.push(...mainBtmThirdRowLeft);
      if (mainBtmThirdRowCenter?.length)
        allBanners.push(...mainBtmThirdRowCenter);
      if (mainBtmThirdRowRight?.length)
        allBanners.push(...mainBtmThirdRowRight);
    }
    return allBanners;
  };

  const mobileBtmSecondBanners = getMobileBanners("second");

  const renderSwiper = (banners) => {
    if (!banners.length) return null;

    return banners.length === 1 ? (
      <a
        href={banners[0].link_url}
        target={banners[0].new_win === "Y" ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        <figure>
          {Array.isArray(banners) &&
          banners[0] &&
          (banners[0].M_FileUrl || banners[0].P_FileUrl) ? (
            <figure>
              <img
                src={banners[0].M_FileUrl || banners[0].P_FileUrl}
                alt={banners[0].img_alt || "배너 이미지"}
              />
            </figure>
          ) : null}
        </figure>
      </a>
    ) : (
      <Swiper
        observer={true}
        observeParents={true}
        spaceBetween={10}
        pagination={{ type: "fraction" }}
        loop={true}
        loopAdditionalSlides={1}
        onSwiper={(swiper) => {
          mobileSwiperRef.current = swiper;
        }}
      >
        {banners.map((banner, i) => (
          <SwiperSlide key={i}>
            <a
              href={banner.link_url}
              target={banner.new_win === "Y" ? "_blank" : "_self"}
              rel="noopener noreferrer"
            >
              {(banner?.M_FileUrl || banner?.P_FileUrl) && (
                <figure>
                  <img
                    src={banner.M_FileUrl || banner.P_FileUrl}
                    alt={banner.img_alt || "배너 이미지"}
                  />
                </figure>
              )}
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };

  return (
    <BannerGridWrapper className="container">
      <BannerSection>
        {/* ✅ PC 전용 배너 */}
        <div className="pc_swiper">
          {banners.map((section, index) => {
            return (
              <BannerBox key={index}>
                <BannerHeader>
                  <TitleWrapper index={index}>{section.title}</TitleWrapper>
                  <h4>{section.subTitle}</h4>
                </BannerHeader>
                {section.data.map((banner, i) => {
                  const linkUrl = banner?.link_url;

                  return (
                    <figure
                      key={i}
                      onClick={() => {
                        if (linkUrl) {
                          router.push(linkUrl);
                        }
                      }}
                      style={{ cursor: linkUrl ? "pointer" : "default" }}
                    >
                      {(banner?.P_FileUrl || banner?.M_FileUrl) && (
                        <img
                          src={banner.P_FileUrl || banner.M_FileUrl}
                          alt={banner.img_alt || "배너 이미지"}
                        />
                      )}
                    </figure>
                  );
                })}
              </BannerBox>
            );
          })}

          {/* 와이드(소) Swiper 추가 */}
          {mainBtmWideSmall?.length > 0 && (
            <BannerBox>
              {mainBtmWideSmall.length > 1 ? (
                <Swiper
                  observer={true}
                  observeParents={true}
                  spaceBetween={10}
                  pagination={{ type: "fraction" }}
                  loop={true}
                  loopAdditionalSlides={1}
                >
                  {mainBtmWideSmall.map((banner, i) => (
                    <SwiperSlide key={i}>
                      <a
                        href={banner.link_url}
                        target={banner.new_win === "Y" ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                      >
                        <figure>
                          {(banner?.P_FileUrl || banner?.M_FileUrl) && (
                            <img
                              src={banner.P_FileUrl || banner.M_FileUrl}
                              alt={banner.img_alt || "배너 이미지"}
                            />
                          )}
                        </figure>
                      </a>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <a
                  href={mainBtmWideSmall[0].link_url}
                  target={
                    mainBtmWideSmall[0].new_win === "Y" ? "_blank" : "_self"
                  }
                  rel="noopener noreferrer"
                >
                  <figure>
                    <img
                      src={
                        mainBtmWideSmall[0].P_FileUrl ||
                        mainBtmWideSmall[0].M_FileUrl
                      }
                      alt={mainBtmWideSmall[0].img_alt}
                    />
                  </figure>
                </a>
              )}
            </BannerBox>
          )}
        </div>

        {/* ✅ 모바일 전용 Swiper 배너 */}
        <div className="m_swiper">
          <BannerBox>
            <BannerHeader>
              <TitleWrapper index={0}>인증받은 상품</TitleWrapper>
              <h4>골라보기</h4>
            </BannerHeader>
            <CertificationImageRow>
              {mainBtmFirstRowLeft?.[0] && (
                <a
                  href={mainBtmFirstRowLeft[0].link_url}
                  aria-label={mainBtmFirstRowLeft[0].img_alt || "스텝포넷제로"}
                >
                  {mainBtmFirstRowLeft?.[0]?.M_FileUrl && (
                    <img
                      src={mainBtmFirstRowLeft[0].M_FileUrl}
                      alt={mainBtmFirstRowLeft[0]?.img_alt || "배너 이미지"}
                    />
                  )}
                  <span>스텝포넷제로</span>
                </a>
              )}

              {mainBtmFirstRowCenter?.[0] && (
                <a
                  href={mainBtmFirstRowCenter[0].link_url}
                  aria-label={mainBtmFirstRowCenter[0].img_alt || "친환경인증"}
                >
                  {mainBtmFirstRowCenter?.[0]?.M_FileUrl && (
                    <img
                      src={mainBtmFirstRowCenter[0].M_FileUrl}
                      alt={mainBtmFirstRowCenter[0]?.img_alt || "배너 이미지"}
                    />
                  )}

                  <span>친환경 인증</span>
                </a>
              )}

              {mainBtmFirstRowRight?.[0] && (
                <a
                  href={mainBtmFirstRowRight[0].link_url}
                  aria-label={mainBtmFirstRowRight[0].img_alt || "FSC인증"}
                >
                  {mainBtmFirstRowRight?.[0]?.M_FileUrl && (
                    <img
                      src={mainBtmFirstRowRight[0].M_FileUrl}
                      alt={mainBtmFirstRowRight[0]?.img_alt || "배너 이미지"}
                    />
                  )}

                  <span>FSC 인증</span>
                </a>
              )}
            </CertificationImageRow>
          </BannerBox>

          <BannerBox>
            <BannerHeader>
              <TitleWrapper index={1}>스페셜 서비스</TitleWrapper>
              <h4>살펴보기</h4>
            </BannerHeader>
            <div style={{ width: "100%" }}>
              {renderSwiper(mobileBtmSecondBanners)}
            </div>
          </BannerBox>
          {mainBtmWideSmall?.length > 0 && (
            <BannerBox>
              <div style={{ width: "100%" }}>
                {mainBtmWideSmall.length > 1 ? (
                  <Swiper
                    observer={true}
                    observeParents={true}
                    spaceBetween={10}
                    pagination={{ type: "fraction" }}
                    loop={true}
                    loopAdditionalSlides={1}
                  >
                    {mainBtmWideSmall.map((banner, i) => (
                      <SwiperSlide key={i}>
                        <a
                          href={banner.link_url}
                          target={banner.new_win === "Y" ? "_blank" : "_self"}
                          rel="noopener noreferrer"
                        >
                          <figure>
                            <img
                              src={banner.M_FileUrl || banner.P_FileUrl}
                              alt={banner.img_alt}
                            />
                          </figure>
                        </a>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <a
                    href={mainBtmWideSmall[0].link_url}
                    target={
                      mainBtmWideSmall[0].new_win === "Y" ? "_blank" : "_self"
                    }
                    rel="noopener noreferrer"
                  >
                    <figure>
                      <img
                        src={
                          mainBtmWideSmall[0].M_FileUrl ||
                          mainBtmWideSmall[0].P_FileUrl
                        }
                        alt={mainBtmWideSmall[0].img_alt}
                      />
                    </figure>
                  </a>
                )}
              </div>
            </BannerBox>
          )}
        </div>
      </BannerSection>
    </BannerGridWrapper>
  );
};

export default HomeMobileBanner;
